import { render, staticRenderFns } from "./Slide1.vue?vue&type=template&id=2b237c1d&scoped=true&"
import script from "./Slide1.vue?vue&type=script&lang=js&"
export * from "./Slide1.vue?vue&type=script&lang=js&"
import style0 from "./Slide1.vue?vue&type=style&index=0&id=2b237c1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b237c1d",
  null
  
)

export default component.exports